// extracted by mini-css-extract-plugin
export var animationContainer = "_jf-0";
export var asteriskIcon = "_jf-8";
export var conversationLeftSection = "_jf-4";
export var conversationListItem = "_jf-3";
export var conversationMiddleSection = "_jf-5";
export var conversationRightSection = "_jf-6";
export var detailsContent = "_jf-1";
export var listContainer = "_jf-7";
export var modalContent = "_jf-2";